import * as Yup from 'yup';
import { WorkOrderType } from '@models';

export function useValidationSchema() {
  return Yup.object<WorkOrderType>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
  }) as Yup.Schema<WorkOrderType>;
}
